export const DATA_ACTIONS = {
  ALLOW_REQUEST_SCHEMA: 'allowRequestSchema',
  SKIP_RESPONSE: 'skipResponse',
  GET_SCHEMA: 'getSchema',
  GET_DATA_HASHES: 'getDataHashes',
  GET_DATA_ITEMS: 'getDataItems',
  GET_STAT_HASHES: 'getStatHashes',
  GET_STAT_ITEMS: 'getStatItems',
  FETCH_SCHEMA: 'fetchSchema',
  FETCH_DATA_HASHES: 'fetchDataHashes',
  FETCH_DATA_ITEMS: 'fetchDataItems',
  FETCH_STAT_HASHES: 'fetchStatHashes',
  FETCH_STAT_ITEMS: 'fetchStatItems',
  SET_SCHEMA: 'setSchema',
  SET_DATA_HASHES: 'setDataHashes',
  SET_DATA_ITEMS: 'setDataItems',
  SET_STAT_HASHES: 'setStatHashes',
  SET_STAT_ITEMS: 'setStatItems',
  WAIT_SCHEMA: 'waitSchema',
  WAIT_DATA_HASHES: 'waitDataHashes',
  WAIT_STAT_HASHES: 'waitStatHashes',
  END_REQUEST_CHAIN: 'endRequestChain',
  SUBJECT_UPDATE: 'subjectUpdate',
  SUBJECT_UPDATE_SET: 'subjectUpdateSet',
  TAGS_UPDATE: 'tagsUpdate',
  TAGS_UPDATE_SET: 'tagsUpdateSet'
} as const

export type DataActionsType = (typeof DATA_ACTIONS)[keyof typeof DATA_ACTIONS]
